import { render, staticRenderFns } from "./BimetallicThermometerViz.vue?vue&type=template&id=674efc02&scoped=true"
import script from "./BimetallicThermometerViz.vue?vue&type=script&lang=js"
export * from "./BimetallicThermometerViz.vue?vue&type=script&lang=js"
import style0 from "./BimetallicThermometerViz.vue?vue&type=style&index=0&id=674efc02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674efc02",
  null
  
)

export default component.exports